const COLOURS = [
  'Grasshopper',
  'Lavender',
  'Flamingo',
  'Fuschia',
  'Fuchsia',
  'Rainbow',
  'Orange',
  'Yellow',
  'Silver',
  'Black',
  'White',
  'Pink',
  'Gold',
  'Blue',
  'Red',
  'Navy',
  'Green',
];

const selected = {
  style: new Set(),
  colour: new Set(),
};

function cards() {
  return [...document.querySelectorAll('.product-grid__item[data-product-title]')];
}

function styleFromTitle(title) {
  if (/mulcotton|malcottan/i.test(title)) return 'Mulcotton Saree';
  if (/kerala/i.test(title)) return 'Kerala Saree';
  return 'Other';
}

function coloursFromTitle(title) {
  return COLOURS.filter((colour) => new RegExp(`\\b${colour}\\b`, 'i').test(title));
}

function unique(values) {
  return [...new Set(values)].sort((a, b) => a.localeCompare(b));
}

function renderOptions(key, values) {
  document.querySelectorAll(`[data-women-filter-options="${key}"]`).forEach((list) => {
    const suffix = list.getAttribute('data-women-filter-suffix') || 'desktop';
    list.innerHTML = values
      .map((value, index) => {
        const id = `women-filter-${key}-${suffix}-${index}`;
        return `
          <li class="facets__inputs-list-item">
            <input type="checkbox" id="${id}" value="${value}" data-women-filter-input="${key}">
            <label for="${id}">${value}</label>
          </li>
        `;
      })
      .join('');
  });
}

function syncInputs() {
  document.querySelectorAll('[data-women-filter-input]').forEach((input) => {
    const key = input.getAttribute('data-women-filter-input');
    if (!key) return;
    input.checked = selected[key].has(input.value);
  });
}

function applyFilters() {
  cards().forEach((card) => {
    const title = card.getAttribute('data-product-title') || '';
    const style = styleFromTitle(title);
    const colours = coloursFromTitle(title);
    const styleOk = selected.style.size === 0 || selected.style.has(style);
    const colourOk =
      selected.colour.size === 0 || colours.some((colour) => selected.colour.has(colour));
    card.hidden = !(styleOk && colourOk);
  });

  document.querySelectorAll('[data-women-filter]').forEach((item) => {
    const key = item.getAttribute('data-women-filter');
    const status = item.querySelector('[data-women-filter-status]');
    if (!status || !key) return;
    const count = selected[key].size;
    status.textContent = count > 1 ? String(count) : count === 1 ? [...selected[key]][0] : '';
  });

  syncInputs();
}

function init() {
  const titles = cards().map((card) => card.getAttribute('data-product-title') || '');
  if (!titles.length) return;

  renderOptions(
    'style',
    unique(titles.map(styleFromTitle).filter((value) => value !== 'Other'))
  );
  renderOptions('colour', unique(titles.flatMap(coloursFromTitle)));

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-women-filter-input]');
    if (!input) return;
    const key = input.getAttribute('data-women-filter-input');
    if (!key) return;
    if (input.checked) selected[key].add(input.value);
    else selected[key].delete(input.value);
    applyFilters();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
